const { initTracking } = require('../../src/tracking');
const { ebayAdsTrackingDispatcher, ebayAdsFlushTrackingData } = require('../../src/tracking/napkin');

const { initGlobalWindowEbayObject } = require('../../src/utils');

module.exports = class {
    onCreate(input) {
        this.state = {
            placementId: input.placementId,
            module: input.module,
            skeletonId: `skeleton${input.placementId}`,
            content: undefined,
        };
    }

    /**
     *
     * @param {modules} response
     * Renders response from napkin on the page
     * renderReady(): => looks at loading parameter to decide when to render the content
     * render(): => initate step-by-step process
     *              - Sync CSS -> Sync [HTML + inline CSS] -> Sync JS -> Async Inline JS -> Async Scripts inside HTML -> Async activate_mod_merch
     */
    renderContent(modules) {
        const { placementId, skeletonId } = this.state;
        if (modules && modules[`PLACEMENT_${placementId}`]) {
            const module = modules[`PLACEMENT_${placementId}`];
            // if module is empty, remove skeleton
            if (Object.keys(module).length === 0) {
                document.getElementById(skeletonId).style.display = 'none';
            } else {
                // eliminates the case where CACHE_MODULE's response is another CACHE_MODULE or it is not HTML_MODULE
                this.state.content = { placementId: placementId, module: module, options: { skeletonId: skeletonId } };
            }
        } else {
            document.getElementById(skeletonId).style.display = 'none';
        }
    }

    /**
     *
     * @param {Napkin URL} cacheURL
     * if data is already available, start rendering
     * else, set a listener
     *      -   When data arrive, start rendering
     *      -   remove the listener ({once: true})
     */
    attachListener(cacheURL) {
        if (window.ebay.ads.cache.find((cacheMeta) => cacheMeta.url && cacheMeta.url === cacheURL && cacheMeta.modules)) {
            this.renderContent(window.ebay.ads.cache.find((cacheMeta) => cacheMeta.url === cacheURL).modules);
        } else {
            document.addEventListener(`nutsCacheResponse:${cacheURL}`, () => {
                this.renderContent(window.ebay.ads.cache.find((cacheMeta) => cacheMeta.url === cacheURL).modules);
            }, { once: true });
        }
    }

    /**
     *
     * @param {Napkin URL} cacheURL
     * Checks if a url is currently queued for processing
     *      - if no:    -   Add url to the global object (window.ebay.ads.cache[].url)
     *                          ex:     window.ebay.ads.cache: [{
     *                                      url: 'https://napkin/1"
     *                                  }];
     *                  -   initate fetch request
     *                  -   on content received, it is stored as an global object
     *                          ex:     window.ebay.ads.cache: [{
     *                                      url: 'https://napkin/1"
     *                                      modules: {...}
     *                                  }];
     */
    startFetchWork(cacheURL) {
        if (!window.ebay.ads.cache.find((cacheMeta) => cacheMeta.url && cacheMeta.url === cacheURL)) {
            window.ebay.ads.cache.push({
                url: cacheURL
            });
            const { placementId, module } = this.state;
            initTracking(module, placementId); // init tracking for module which is making request
            ebayAdsTrackingDispatcher('url', placementId, cacheURL); // Dispatch an event when url has arrived
            fetch(cacheURL)
                .then((res) => {
                    ebayAdsTrackingDispatcher('httpCode', placementId, res.status);
                    if (!res.ok) {
                        throw new Error(`HTTP status ${res.status}`);
                    }
                    return res.json();
                })
                .then((response) => {
                    if (response && response.modules) {
                        const placementIds = [];
                        Object.keys(response.modules)
                            .filter((key) => key.indexOf('PLACEMENT_') !== -1)
                            .forEach((PLACEMENT_PLACEMENTID) => {
                                const regexp = /.*?PLACEMENT_(\d+)/;
                                const regexpRes = regexp.exec(PLACEMENT_PLACEMENTID);
                                if (regexpRes !== null && regexpRes[1]) {
                                    placementIds.push(parseInt(regexpRes[1], 10));
                                }
                            });
                        window.ebay.ads.cache.find((cacheMeta) => cacheMeta.url === cacheURL).modules = response.modules;
                        ebayAdsTrackingDispatcher('placementIds', placementId, placementIds); // dispatch event with all placement Ids in cache response
                    }
                })
                .catch((error) => {
                    ebayAdsTrackingDispatcher('error', placementId, error.message);
                    ebayAdsTrackingDispatcher('httpCode', placementId, -1); // dispatch event with httpCode
                    ebayAdsTrackingDispatcher('placementIds', placementId, []);
                })
                .finally(() => {
                    document.dispatchEvent(new Event(`nutsCacheResponse:${cacheURL}`));
                    ebayAdsFlushTrackingData(placementId);
                });
        }
    }

    onInput(input) {
        if (this.state.module !== input.module) {
            this.state.module = input.module;
            this.state.options = input.options;
            this.beginRendering();
        }
    }

    onMount() {
        initGlobalWindowEbayObject();
        this.beginRendering();
    }

    beginRendering() {
        const { module } = this.state;
        // Before any of the module is looked for processing. We should have url in the modules
        if (module && module.cache && module.cache.url) {
            const cacheURL = module.cache.url;
            // for each url, go to napkin and get content (Function is only proceesed for unqiue url's)
            this.startFetchWork(cacheURL);
            // for each placement wait for content and then render
            this.attachListener(cacheURL);
        }
    }
};
